import React, { useEffect, useState } from 'react';
import { DataProviderInstance } from '../../api/DataProvider';
import styles from './DocumentsTemplates.module.css';
import Loading from '../../components/loading/Loading.js';
import AreaTitle from '../../components/areaTitle/AreaTitle';
import {
    Box,
    Typography,
    Snackbar,
    Alert
} from '@mui/material';
import {
    Add as AddIcon,
    DescriptionOutlined as DocumentIcon,
    InfoOutlined as InfoOutlinedIcon
} from '@mui/icons-material/';
import CustomButton from '../../components/buttons/CustomButton';
import CreateEditTemplateDocument from '../../popup/CreateEditTemplateDocument/CreateEditTemplateDocument';
import ConfirmPopup from '../../popup/ConfirmPopup/ConfirmPopup';
import DocumentCard from './components/DocumentCard';
import DocumentPreviewModal from './components/DocumentPreviewModal';

const DocumentsTemplates = () => {
    const { GetTemplatesDocuments, DeleteTemplatesDocuments } = DataProviderInstance();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [confirmPopupData, setConfirmPopupData] = useState({title: "", description: ""});

    const [currentItem, setCurrentItem] = useState(null);
    const [isVisibleDocumentInfo, setIsVisibleDocumentInfo] = useState(false);
    const [isVisibleConfirmPopup, setIsVisibleConfirmPopup] = useState(false);
    const [isPreviewModalVisible, setIsPreviewModalVisible] = useState(false);
    const [previewTemplate, setPreviewTemplate] = useState(null);
    
    // Estado para notificações
    const [notification, setNotification] = useState({ open: false, message: '', severity: 'success' });

    useEffect(() => {
        loadDocumentsTemplate(() => setLoading(false));
    }, []);

    const loadDocumentsTemplate = (callback) => {
        GetTemplatesDocuments((response) => {
            setData(response)
            if(callback) callback();
        });
    }

    if (loading) {
        return <Loading />;
    }

    const handleAddDocument = () => {
        setCurrentItem(null);
        setIsVisibleDocumentInfo(true);
    };

    const handleEditDocument = (template) => {
        setCurrentItem(template);
        setIsVisibleDocumentInfo(true);
    };

    const handleDeleteDocument = (template) => {
        setCurrentItem(template);

        setConfirmPopupData({
            title: "Apagar modelo",
            description: `Deseja realmente apagar o modelo <strong>${template.tag || template.title}</strong>?`
        });

        setIsVisibleConfirmPopup(true);
    };

    const handleClose = () => {
        setIsVisibleDocumentInfo(false);
        setCurrentItem(null);
    };

    const handleReloadDocumentsTemplate = () => {
        setIsVisibleDocumentInfo(false);
        loadDocumentsTemplate();
    }

    const handleConfirmAction = (action) => {
        if(action == "delete_documents") {
            DeleteTemplatesDocuments(currentItem.id, (response) => {
                handleReloadDocumentsTemplate();
            });
        }
    }

    const handleConfirmPopupHide = () => {
        setIsVisibleConfirmPopup(false);
        setCurrentItem(null);
    }

    const handlePreviewDocument = (template) => {
        setPreviewTemplate(template);
        setIsPreviewModalVisible(true);
    };

    const handleClosePreview = () => {
        setIsPreviewModalVisible(false);
        setPreviewTemplate(null);
    };

    const handleCopyDocument = (template) => {
        setNotification({
            open: true,
            message: 'Conteúdo do documento copiado para a área de transferência!',
            severity: 'success'
        });
    };

    const handleCloseNotification = () => {
        setNotification({ ...notification, open: false });
    };

    return (
        <div className={styles.container}>
            {isVisibleConfirmPopup && (
                <ConfirmPopup 
                    Visibility={isVisibleConfirmPopup} 
                    Title={confirmPopupData.title} 
                    Description={confirmPopupData.description} 
                    ConfirmLabel={"Apagar"} 
                    OnConfirm={() => handleConfirmAction("delete_documents")} 
                    OnHide={handleConfirmPopupHide}
                />
            )}
            {isVisibleDocumentInfo && (
                <CreateEditTemplateDocument 
                    Data={currentItem} 
                    OnUpdate={handleReloadDocumentsTemplate} 
                    OnHide={handleClose} 
                />
            )}
            
            <div className={styles.header}>
                <CustomButton
                    style="secondary"
                    variant="contained"
                    icon={<AddIcon />}
                    label="Adicionar modelo"
                    onClick={handleAddDocument}
                />
            </div>
            
            {data.length > 0 ? (
                <div className={styles.templatesGrid}>
                    {data.map((template) => (
                        <DocumentCard
                            key={template.id}
                            template={template}
                            onEdit={handleEditDocument}
                            onDelete={handleDeleteDocument}
                            onPreview={handlePreviewDocument}
                            onCopy={handleCopyDocument}
                        />
                    ))}
                </div>
            ) : (
                <div className={styles.emptyState}>
                    <InfoOutlinedIcon className={styles.emptyStateIcon} />
                    <Typography variant="body1" className={styles.emptyStateText}>
                        Nenhum modelo de documento cadastrado
                    </Typography>
                    <Typography variant="body2" className={styles.emptyStateSubtext}>
                        Crie modelos personalizados para seus documentos e recibos
                    </Typography>
                    <Box sx={{ mt: 2 }}>
                        <CustomButton
                            style="secondary"
                            variant="contained"
                            icon={<AddIcon />}
                            label="Adicionar modelo"
                            onClick={handleAddDocument}
                        />
                    </Box>
                </div>
            )}

            {/* Modal de Preview */}
            <DocumentPreviewModal
                open={isPreviewModalVisible}
                onClose={handleClosePreview}
                template={previewTemplate}
                onCopy={handleCopyDocument}
            />

            {/* Notificações */}
            <Snackbar
                open={notification.open}
                autoHideDuration={3000}
                onClose={handleCloseNotification}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            >
                <Alert
                    onClose={handleCloseNotification}
                    severity={notification.severity}
                    variant="filled"
                >
                    {notification.message}
                </Alert>
            </Snackbar>
        </div>
    );
};

export default DocumentsTemplates;